export const PASSWORD_INVALID_MESSAGE = "Debe tener al menos 6 caracteres de largo, 1 mayuscula, 1 minuscula, 1 caracter especial ( @ . - _ *) y no debe poseer espacios";
